import { gql } from "@apollo/client";

// Node-path lookup for the Move modal: resolves the client tree root
// (pathNodes[0]) for same-client picker scoping. installationDate and
// averageRuntimePerDay feed the removalDate→runningTime prefill recompute
// (see moveWizardSync.ts).
export const MoveInstalledBaseNodeContext = gql`
    query MoveInstalledBaseNodeContext ($id: ID!) {
        installedBaseNode (id: $id) {
            id
            title
            nodeType {
                id
                key
                name
            }
            assetLocation {
                id
                installationDate
                averageRuntimePerDay
            }
            pathNodes {
                id
                title
            }
        }
    }
`;
